import React, {useEffect, useState} from 'react';
import {
  calculateAgentPercentDiscount,
  calculateDiscount,
  getRealUnitPrice
} from "../../models/cartItem";
import {agentFieldClassName} from "../utility/cartHelpers";

/**
 * 2025-05 heavily refactored and simplified. All calculation now happens on the front end.
 *
 * @param item
 * @param agentUnitPrice
 * @param updateUnitPrice
 * @param commitChanges
 * @param violated
 * @param readOnly
 * @returns {JSX.Element}
 * @constructor
 */
export default function AgentPercentDiscountField({
  item,
  agentUnitPrice,
  updateUnitPrice,
  commitChanges,
  violated = false,
  readOnly = false
}) {
  const [focused, setFocused] = useState(false);

  const [displayValue, setDisplayValue] = useState(null);
  const [percentOff, setPercentOff] = useState(null);

  const realUnitPrice = getRealUnitPrice(item);
  const discountGiven = agentUnitPrice ? (realUnitPrice - agentUnitPrice) : null;

  useEffect(() => {
    let percent = calculateAgentPercentDiscount({agentUnitPrice, item});

    if (percentOff?.toFixed(1) !== percent?.toFixed(1))
      setPercentOff(percent);

    setDisplayValue(formatValue(percent));
  }, [realUnitPrice, agentUnitPrice, item])

  function handleInput(evt) {
    let rawValue = evt.target.value;

    const discountPercent = +(rawValue);  // like 5, 10, 20;

    const agentDiscountCents = calculateDiscount({discountPercent, fullPrice: realUnitPrice, item});
    const newUnitPrice = realUnitPrice - agentDiscountCents;

    console.log(`new price is ${newUnitPrice}, full=${realUnitPrice}`);
    updateUnitPrice(newUnitPrice);
  }

  function handleBlur() {
    setFocused(false);
    commitChanges();
  }

  let className = agentFieldClassName({violated, focused});
  let valueAttrs = focused ? {defaultValue: displayValue || ''} : {value: displayValue};

  return <div>
    <input
      type="number" min="0" max="100"
      className={className}
      placeholder="% off"
      {...valueAttrs}
      onInput={handleInput}
      onFocus={() => setFocused(true)}
      onBlur={handleBlur}
      readOnly={readOnly || false}
    />
    {discountGiven && <ResultDisplay
      realUnitPrice={realUnitPrice}
      percentOff={percentOff}
      discountGiven={discountGiven}
    />}
  </div>
}

function formatValue(val) {
  if (!val) return "";

  let text = `${(+val).toFixed(1)}`;
  text = text.replace(/\.0+$/, '');
  return text;
}

function ResultDisplay({realUnitPrice, percentOff, discountGiven}) {
  return (
    <div className='text-xs'>
      <span className="whitespace-nowrap">
        ${new Money(realUnitPrice).toDollars()}
        <span className="fa fa-times"/>
        {percentOff?.toFixed(1)}%
      </span>

      <span className="whitespace-nowrap">
        <span className="fa fa-equals mx-1"/>
        {new Money(discountGiven).toDollars()}
      </span>
    </div>)
}

